function escape(value) {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
export var htmlRender = {
    text: function (chunk) { return escape(chunk); },
    join: function (chunks) { return chunks.join(''); },
    wrap: function (className, chunk) { return "<span class=\"" + className + "\">" + chunk + "</span>"; }
};
//# sourceMappingURL=html.js.map